import type { TabPath } from '../constants';

/** First path segment: `/rules/123` → `/rules`, `/rules` → `/rules`. */
const LEADING_PATH_SEGMENT = /^(\/[^/]+)/;

/** Routes that belong under Home, e.g. the game view (`/game-view`) and any of its sub-routes. */
const HOME_NESTED_ROUTE = /^\/game-view(\/|$)/;

/**
 * Maps the current URL to the tab `value` used for active nav styling.
 *
 * Pathname → the first path segment (`/rules/…` → `/rules`), including
 * nested routes like `/rules/123/create`.
 */
export function getActiveTabPath(pathname: string): null | TabPath {
  if (pathname === '/' || HOME_NESTED_ROUTE.test(pathname)) return '/';

  const matches = LEADING_PATH_SEGMENT.exec(pathname);
  const path = matches?.[1];
  if (!path) return null;

  return path as TabPath;
}
